import { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";

import type { CrmEnrichmentJob } from "../types/types";

type SyncQueryKeys = {
    readonly job: (id: string) => readonly string[];
};

export const useCrmEnrichmentJobsDataSync = (
    data: readonly CrmEnrichmentJob[] | undefined,
    queryKeys: SyncQueryKeys,
): void => {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!data) {
            return;
        }

        data.forEach((job) => {
            queryClient.setQueryData(queryKeys.job(job.id), job);
        });
    }, [data, queryClient, queryKeys]);
};
